import { GrupoMenu, MenuFiltro, OpcaoMenu } from "./BarraFiltros";

export type DataDoFiltro = "execucao" | "fatal";
export type Periodo = "qualquer" | "vencidas" | "hoje" | "7dias" | "30dias";

const PERIODOS: { valor: Periodo; rotulo: string; curto: string }[] = [
  { valor: "qualquer", rotulo: "Qualquer data", curto: "" },
  { valor: "vencidas", rotulo: "Vencidas", curto: "vencidas" },
  { valor: "hoje", rotulo: "Hoje", curto: "hoje" },
  { valor: "7dias", rotulo: "Próximos 7 dias", curto: "7 dias" },
  { valor: "30dias", rotulo: "Próximos 30 dias", curto: "30 dias" },
];

/**
 * Período da lista: primeiro QUAL data (execução ou prazo fatal), depois o intervalo. Fechado, o botão diz só
 * "Período"; com um intervalo escolhido, "Fatal · 7 dias". Os limites saem da API (dia útil é regra, §5.1).
 */
export function MenuPeriodo({ data, periodo, aoMudar, abertoInicial }: {
  data: DataDoFiltro; periodo: Periodo; aoMudar: (data: DataDoFiltro, periodo: Periodo) => void; abertoInicial?: boolean;
}) {
  const escolhido = PERIODOS.find((p) => p.valor === periodo)!;
  const valor = periodo === "qualquer" ? null : `${data === "fatal" ? "Fatal" : "Execução"} · ${escolhido.curto}`;
  return (
    <MenuFiltro rotulo="Período" valor={valor} abertoInicial={abertoInicial}>
      <GrupoMenu titulo="Data">
        <OpcaoMenu marcada={data === "fatal"} aoEscolher={() => aoMudar("fatal", periodo)}>Prazo fatal</OpcaoMenu>
        <OpcaoMenu marcada={data === "execucao"} aoEscolher={() => aoMudar("execucao", periodo)}>Execução</OpcaoMenu>
      </GrupoMenu>
      <div className="fio-t" />
      <GrupoMenu titulo="Período">
        {PERIODOS.map((p) => (
          <OpcaoMenu key={p.valor} marcada={periodo === p.valor} aoEscolher={() => aoMudar(data, p.valor)}>{p.rotulo}</OpcaoMenu>
        ))}
      </GrupoMenu>
    </MenuFiltro>
  );
}
